// export const baseurl = "http://localhost:5000"; 

// test url
// export const baseurl = "http://62.72.31.160:4000";

// export const baseurl = "http://62.72.31.160:5000" ;

export const baseurl = "https://sktt.in:5000";